import "./projects.css";
import phone from "./img/phone.png";
import laptop from "./img/laptop.png";
import phoneApp from "./img/screenCake.png";
import laptopApp from "./img/screenLG.png";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import mongoImg from "./img/mongodb.png";
import axiosImg from "./img/Axios_(computer_library)_logo.svg.png";
import reduxImg from "./img/Redux.png";
import jsImg from "./img/Unofficial_JavaScript_logo_2.svg.png";
import expressImg from "./img/express.png";
import firebaseImg from "./img/firebase.png";
import muiImg from "./img/mui.png";
import jwtImg from "./img/jwt.png";
import reactImg from "./img/react.png";
import nodeImg from "./img/node.png";
import cssImg from "./img/css.png";
import htmlImg from "./img/html.png";
import gitImg from "./img/git.png";
import styledImg from "./img/styled_components.png";
import stripeImg from "./img/stripe.svg";

export default function Projects () {
    useEffect(() => {
        const projectsTitle = document.querySelector('.projectsTitle')
        const phone = document.querySelector('.phone')
        const laptop = document.querySelector('.laptop')
        
        let projectsTitlePosition = projectsTitle.getBoundingClientRect().top;
        let phonePosition = phone.getBoundingClientRect().top;
        let laptopPosition = laptop.getBoundingClientRect().top;


    //    console.log(projectsTitlePosition)
        window.addEventListener("scroll", ()=>{
            let offsetY = window.scrollY;
            //console.log(offsetY)
            let offsetProjectTitle = projectsTitlePosition - offsetY;
            let offsetPhone = phonePosition - offsetY;
            let offsetLaptop = laptopPosition - offsetY;
          //console.log(offsetProjectTitle)
            projectsTitle.style.transform=`translateY(${offsetProjectTitle*0.5}px)`
            phone.style.transform=`translateX(${offsetPhone}px)`
            laptop.style.transform=`translateX(${offsetLaptop}px)`
           
        })
    }, []);



    return (
        <div className="projects">
                <h1 className="projectsTitle">My projects and skills</h1>
                <div className="logos">
                    <img src={jsImg} alt="" className="logo" />
                    <img src={htmlImg} alt="" className="logo" /> 
                    <img src={cssImg} alt="" className="logo" />   
                    <img src={mongoImg} alt="" className="logo" />
                    <img src={expressImg} alt="" className="logo" />
                    <img src={reactImg} alt="" className="logo" />
                    <img src={nodeImg} alt="" className="logo" />
                    <img src={jwtImg} alt="" className="logo" />
                    <img src={axiosImg} alt="" className="logoAxios" />
                    <img src={reduxImg} alt="" className="logo" />
                    <img src={firebaseImg} alt="" className="logo" />
                    <img src={stripeImg} alt="" className="logo" />
                    <img src={muiImg} alt="" className="logo" />
                    <img src={styledImg} alt="" className="logo" />
                    <img src={gitImg} alt="" className="logo" />
                    
                
                </div>
                <div className="project">
                    <div className="phone">
                        <img src={phone} alt="" className="phoneImg" />
                        <div className="phoneScreen">
                            <img src={phoneApp} alt="" className="phoneApp" />
                        </div>
                    </div>
                    <div className="projectDetail">
                        <h1 className="projectTitle">Yummy Cakes</h1>
                        <p className="projectDesc">An eCommerce project developed 
                        using MERN technologies. It is a vast project involving front and back-end technologies 
                        and database knowledge for efficient execution and implementation.
                        Also developed an application for administration of eCommerce app, which allows working with products, 
                        users, administration of sales statistics, etc.
                        </p>
                        <Link to="https://yummycakesuser.vercel.app/">
                            <button className="projectButton">Visit</button>
                        </Link>
                        {/* <button className="projectButton">Visit</button> */}
                    </div>
                </div>
                <div className="project">
                    <div className="laptop">
                        <img src={laptop} alt="" className="laptopImg" />
                        <div className="laptopScreen">
                            <img src={laptopApp} alt="" className="laptopApp" />
                        </div>
                    </div>
                    <div className="projectDetail">
                        <h1 className="projectTitle">Learn&Grow</h1>
                        <p className="projectDesc">A learning platform developed for schoolchildren. Allows schoolchildren to write down and use all the necessary knowledge previously entered. It is a vast project involving front and back-end technologies and database knowledge for efficient execution and implementation.</p>
                        <Link to="https://learnandgrow.vercel.app/">
                            <button className="projectButton">Visit</button>
                        </Link>
                        
                        {/* <button className="projectButton">Visit</button> */}
                    </div>
                </div>
                
        </div>
    )
}
